import {useCallback} from "react";
import {useGetProfileContext} from "../../context/profile/profile-context";
import {clearOfferingCreateDraft} from "./clear-offering-create-draft";
import type {OfferingCreateDraftKey} from "./storage-keys";

/**
 * Returns a callback that clears the current user's scoped offering draft.
 */
export function useClearOfferingCreateDraft(draftKey: OfferingCreateDraftKey) {
  const {state: profileState} = useGetProfileContext();

  return useCallback(() => {
    clearOfferingCreateDraft({
      draftKey,
      email: profileState.profileData.email,
    });
  }, [draftKey, profileState.profileData.email]);
}
